import axios from 'axios';

/**
 *
 */
export default {

    data() {
        return {
            overlay: null,
        };
    },

    methods: {
        /**
         *
         */
        async loadMapOverlay() {
            try {
                const res = await axios.get(this.overlayURL);
                this.$refs.map.insertAdjacentHTML('beforeend', res.data);
                await this.$nextTick();
                this.overlay = this.$refs.map.querySelector('svg');
                this.overlay.classList.add('map-overlay');
            } catch (e) {
                console.error('Error loading map overlay svg', e);
            }
        },
    },
};
